module.exports = __webpack_public_path__ + "static/img/hhd_vip_06.98f40c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member/hhd_vip_06.jpg
// module id = oelF
// module chunks = 1